export default {
  getConfig: state => state.config,
  getUserProfile: state => state.profile,
  getPortalInfo: state => state.portalInfo,
  getToken: state => state.token,
  getAcceptTerms: state => state.acceptTerms
};
